import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  useMemo,
} from "react";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
const homeBanner = [
   
    {
        "id": "1a5800e9-3240-4a3e-a140-253ea5ccd504",
        "is_active": true,
        "createdTime": "2025-12-06T04:03:16.284Z",
        "updatedTime": "2026-03-05T20:01:59.365Z",
        "bannerImageUrl": "/images/b1.webp",
        "bannerVideoUrl": "",
        "orderNumber": 0,
        "mobilebannerVideoUrl": "",
        "mobilebannerImageUrl": "/images/b3.webp",
        "Title": "LSB Banner",
        "description": ""
    }
]
const Banner = ({ sectionData }) => {
  const dispatch = useDispatch();

  const [currentSlide, setCurrentSlide] = useState(0);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [videoReady, setVideoReady] = useState({});

  const videoRefs = useRef([]);
  const hasFetched = useRef(false);

  const dotColor =
    sectionData?.colors?.[process.env.REACT_APP_BANNER_DOT_COLOR_ID] ||
    "var(--primary-color)";

  useEffect(() => {
   
  }, [dispatch]);

  useEffect(() => {
    const resize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", resize);
    return () => window.removeEventListener("resize", resize);
  }, []);

  const sortedSlides = useMemo(() => {
    return [...homeBanner]
      .filter((s) => s.is_active && s.Title)
      .sort((a, b) => a.orderNumber - b.orderNumber);
  }, [homeBanner]);

  const nextSlide = useCallback(() => {
    setCurrentSlide((prev) =>
      sortedSlides.length ? (prev + 1) % sortedSlides.length : 0
    );
  }, [sortedSlides.length]);

  const getMedia = useCallback(
    (slide) => {
      const isMobile = screenWidth <= 1100;

      let video = isMobile
        ? slide.mobilebannerVideoUrl
        : slide.bannerVideoUrl;

      let image = isMobile
        ? slide.mobilebannerImageUrl
        : slide.bannerImageUrl;

      if (isMobile && !video && !image) {
        video = slide.bannerVideoUrl;
        image = slide.bannerImageUrl;
      }

      if (video) return { type: "video", video, image };
      if (image) return { type: "image", image };

      return null;
    },
    [screenWidth]
  );

  useEffect(() => {
    if (!sortedSlides.length) return;

    const slide = sortedSlides[currentSlide];
    const media = getMedia(slide);

    if (media?.type === "image") {
      const timer = setTimeout(nextSlide, 6000);
      return () => clearTimeout(timer);
    }

    const videoEl = videoRefs.current[currentSlide];
    if (!videoEl || !media?.video) return;

    setVideoReady((prev) =>
      prev[currentSlide] === false
        ? prev
        : { ...prev, [currentSlide]: false }
    );

    videoEl.src = media.video;
    videoEl.muted = true;
    videoEl.playsInline = true;
    videoEl.preload = "auto";

    const onReady = () => {
      setVideoReady((prev) => ({ ...prev, [currentSlide]: true }));
      videoEl.play().catch(() => {});
    };

    const onEnd = () => nextSlide();

    videoEl.addEventListener("loadeddata", onReady);
    videoEl.addEventListener("ended", onEnd);
    videoEl.load();

    return () => {
      videoEl.removeEventListener("loadeddata", onReady);
      videoEl.removeEventListener("ended", onEnd);
    };
  }, [currentSlide, sortedSlides, getMedia, nextSlide]);

  return (
    <HeroSection style={{minHeight:'80vh'}}>
      <SliderWrapper>
        {sortedSlides.map((slide, idx) => {
          const media = getMedia(slide);

          return (
            <Slide key={slide.id} isActive={idx === currentSlide}>
              {media?.type === "video" && (
                <>
                  <FallbackImage
                    src={media.image}
                    alt={slide.Title}
                    isVisible={!videoReady[idx]}
                  />

                  <SlideVideo
                    ref={(el) => (videoRefs.current[idx] = el)}
                    isVisible={videoReady[idx]}
                  />
                </>
              )}

              {media?.type === "image" && (
                <SlideImage src={media.image} alt={slide.Title} />
              )}

              <Overlay />
            </Slide>
          );
        })}

        {sortedSlides.length > 1 && (
          <Dots>
            {sortedSlides.map((_, idx) => (
              <Dot
                key={idx}
                isActive={idx === currentSlide}
                dotColor={dotColor}
                onClick={() => setCurrentSlide(idx)}
              />
            ))}
          </Dots>
        )}
      </SliderWrapper>
    </HeroSection>
  );
};

export default Banner;
const HeroSection = styled.section`
  width: 100%;
  position: relative;
  overflow: hidden;
`;

const SliderWrapper = styled.div`
  width: 100%;
  position: relative;
`;

const Slide = styled.div`
  width: 100%;
  position: relative;
  display: ${(p) => (p.isActive ? "block" : "none")};
`;

const SlideVideo = styled.video`
  width: 100%;
  min-height: 80vh;
  object-fit: cover;
  opacity: ${(p) => (p.isVisible ? 1 : 0)};
  transition: opacity 0.6s ease;

  @media (max-width: 1024px) {
    // min-height: 60vh;
    width: 100%;
  }
`;

const SlideImage = styled.img`
  width: 100%;
  object-fit: cover;
min-height: 60vh;
  @media (max-width: 1024px) {
    min-height: 60vh;
  }
`;

const FallbackImage = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  min-height: 80vh;
  object-fit: cover;
  z-index: 2;
  opacity: ${(p) => (p.isVisible ? 1 : 0)};
  transition: opacity 0.6s ease;
`;

const Overlay = styled.div`
  position: absolute;
  inset: 0;
`;

const Dots = styled.div`
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 8px;
  z-index: 10;
`;

const Dot = styled.span`
  width: 28px;
  height: 7px;
  border-radius: 10px;
  background: ${(p) => (p.isActive ? p.dotColor : "#aaa")};
  cursor: pointer;
`;
